import styled from "styled-components"

export const Prose = styled.div`
  max-width: var(--measure);
  strong {
    display: block;
    margin: 1.75rem 0 0.5rem;
    font-family: var(--font-display);
    font-weight: 700;
    font-size: 1.25rem;
    color: var(--ink);
  }
  p {
    margin-bottom: 1rem;
  }
  a {
    word-break: break-all;
  }
`
